import {
    Component,
    ComponentFactory,
    ComponentFactoryResolver,
    ComponentRef,
    EventEmitter,
    HostListener,
    Input,
    OnInit,
    Output,
    ViewChild,
    ViewContainerRef
} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {RestService} from '../services/rest.service';
import {UIBlockerService} from '../services/uiblocker.service';
import {DataService} from '../services/data.service';
import {finalize, tap} from 'rxjs/operators';
import {isNullOrUndefined} from '../shared/is-null-or-undefined';
import {DialogGeneralComponent} from '../dialog-general/dialog-general.component';
import {environment} from '../../environments/environment';
import {TranslationService} from '../services/translation.service';

@Component({
    selector: 'app-dialog-car',
    templateUrl: './dialog-car.component.html',
    styleUrls: ['./dialog-car.component.css'],
})
export class DialogCarComponent implements OnInit {

    @ViewChild('dialogsContainer2', {read: ViewContainerRef, static: true}) dialogsContainer2;
    dialogRef: ComponentRef<DialogGeneralComponent>;

    @Input() headerText: string;
    @Input() carItem: any;

    @Output() onDialogConfirm: EventEmitter<any> = new EventEmitter<any>();
    @Output() onDialogCancel: EventEmitter<void> = new EventEmitter<void>();
    @Output() onCarUpdated: EventEmitter<void> = new EventEmitter<void>();

    changeSuspendReason: string;
    carDetails: any;
    sessionId: any;
    canUnpairDevice = false;
    shouldUnpairBeVisible = true;
    baseUrlForImages: string = environment.driverResourcesUrl;
    carIdentifier: any;
    showReason: boolean = false;
    suspendReason: string;
    suspensionHours: number;
    showPriceInput: boolean = false;
    priceInput: number;
    packageType: string;
    notificationMessage = '';
    notificationType = 'info';
    private notificationTimer: any;

    constructor(private activatedRoute: ActivatedRoute,
                private restService: RestService,
                private uiBlockerService: UIBlockerService,
                private dataService: DataService,
                private router: Router,
                private resolver: ComponentFactoryResolver,
                private translationService: TranslationService) { /* noop */
    }

    ngOnInit() {
        this.sessionId = this.dataService.getSessionIdentifier();
        // try to make the request
        this.checkIfUserCanUnpairDevice();
        this.makeCarDetailsRequest();

        // session id is empty so we must ve after a refesrh so we should wait for data change event and then

        // make the call
        this.dataService.dataChangedSession.subscribe(() => {

            this.sessionId = this.dataService.getSessionIdentifier();
            // try to make the request
            this.checkIfUserCanUnpairDevice();
            this.makeCarDetailsRequest();
        });
    }

    @HostListener('document:keydown.escape', ['$event'])
    onEscapeKey(event: KeyboardEvent) {
        if (event.defaultPrevented || this.hasActiveGeneralDialog()) {
            return;
        }

        event.preventDefault();
        this.onCloseClick();
    }

    checkIfUserCanUnpairDevice() {
        this.canUnpairDevice = false;
        const userData = this.dataService.getUserInfo();
        if (!isNullOrUndefined(userData) && !isNullOrUndefined(userData.Permissions)) {
            for (const permission of userData.Permissions) {
                if (String(permission).trim().toLowerCase() === 'canunpairdevice') {
                    this.canUnpairDevice = true;
                    break;
                }
            }
        }
    }

    makeCarDetailsRequest() {
        if (!isNullOrUndefined(this.sessionId)) {
            this.getCarDetails();
        } else { /* noop */
        }
    }

    makeUnpairDeviceRequest() {
        // one final check to see if user has this permission
        if (this.canUnpairDevice) {
            this.unpairDevice();
        }
    }

    showUnpairDeviceDialog() {
        // we should should the dialog - event if we are inside another dialog
        const dialogTexts: any = {
            HeaderText: 'Unpair Device Confirmation',
            BodyText: 'Are you sure you want to unpair this device?',
            ConfirmButtonText: 'Yes',
            CancelButtonText: 'No'
        };
        // Create Dialog Component:
        this.dialogsContainer2.clear();
        const factory: ComponentFactory<DialogGeneralComponent> = this.resolver

            .resolveComponentFactory(DialogGeneralComponent);
        this.dialogRef = this.dialogsContainer2.createComponent(factory);
        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.bodyText = dialogTexts.BodyText;
        this.dialogRef.instance.confirmButtonText = dialogTexts.ConfirmButtonText;
        this.dialogRef.instance.cancelButtonText = dialogTexts.CancelButtonText;
        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.onUnpairConfirm();
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            this.onUnpairCancel();
            this.dialogRef.destroy();
        });
    }

    testNewBtn() {
        const dialogTexts: any = {
            HeaderText: 'Drink Safe Confirmation',
            BodyText: 'Are you sure you want to enable drink safe?',
            ConfirmButtonText: 'Yes',
            CancelButtonText: 'No'
        };

        // Create Dialog Component:
        this.dialogsContainer2.clear();
        const factory: ComponentFactory<DialogGeneralComponent> = this.resolver

            .resolveComponentFactory(DialogGeneralComponent);
        this.dialogRef = this.dialogsContainer2.createComponent(factory);

        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.bodyText = dialogTexts.BodyText;
        this.dialogRef.instance.confirmButtonText = dialogTexts.ConfirmButtonText;
        this.dialogRef.instance.cancelButtonText = dialogTexts.CancelButtonText;

        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.updateDrinkSafe(true);
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            this.updateDrinkSafe(false);
            this.dialogRef.destroy();
        });
    }

    selectPackage() {
        const dialogTexts: any = {
            HeaderText: 'Drink Safe Confirmation',
            BodyText: 'Alege pachet',
            ConfirmButtonText: 'Submit',
            CancelButtonText: 'Cancel',
            showPriceInput: true
        };

        // Create Dialog Component:
        this.dialogsContainer2.clear();
        const factory: ComponentFactory<DialogGeneralComponent> = this.resolver

            .resolveComponentFactory(DialogGeneralComponent);
        this.dialogRef = this.dialogsContainer2.createComponent(factory);

        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.bodyText = dialogTexts.BodyText;
        this.dialogRef.instance.confirmButtonText = dialogTexts.ConfirmButtonText;
        this.dialogRef.instance.cancelButtonText = dialogTexts.CancelButtonText;
        this.dialogRef.instance.showPriceInput = true;

        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.updatePackage();
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            // this.onUnpairCancel();
            // if(this.isTest){
            //   this.updatePackageTest()
            // }else{
            //   this.updatePackage()
            // }
            this.dialogRef.destroy();
        });
    }

    suspendCar() {
        const dialogTexts: any = {
            HeaderText: 'Suspend Confirmation',
            BodyText: 'Are you sure you want to suspend this driver?',
            ConfirmButtonText: 'Yes',
            CancelButtonText: 'No',
            showReason: true
        };

        // Create Dialog Component:
        this.dialogsContainer2.clear();
        const factory: ComponentFactory<DialogGeneralComponent> = this.resolver

            .resolveComponentFactory(DialogGeneralComponent);
        this.dialogRef = this.dialogsContainer2.createComponent(factory);

        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.bodyText = dialogTexts.BodyText;
        this.dialogRef.instance.confirmButtonText = dialogTexts.ConfirmButtonText;
        this.dialogRef.instance.cancelButtonText = dialogTexts.CancelButtonText;
        this.dialogRef.instance.showReason = true;

        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.suspendDriver();
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            // this.updateDrinkSafe(false)
            this.dialogRef.destroy();
        });
    }

    unsuspendCar() {
        const dialogTexts: any = {
            HeaderText: 'Unsuspend Confirmation',
            BodyText: 'Are you sure you want to unsuspend this driver?',
            ConfirmButtonText: 'Yes',
            CancelButtonText: 'No',
            // showReason: true
        };

        // Create Dialog Component:
        this.dialogsContainer2.clear();
        const factory: ComponentFactory<DialogGeneralComponent> = this.resolver

            .resolveComponentFactory(DialogGeneralComponent);
        this.dialogRef = this.dialogsContainer2.createComponent(factory);

        // Customize with texts:
        this.dialogRef.instance.headerText = dialogTexts.HeaderText;
        this.dialogRef.instance.bodyText = dialogTexts.BodyText;
        this.dialogRef.instance.confirmButtonText = dialogTexts.ConfirmButtonText;
        this.dialogRef.instance.cancelButtonText = dialogTexts.CancelButtonText;
        // this.dialogRef.instance.showReason = true // this line is responsible for the reason input and the

        // radio buttons

        // Listen for Dialog Events (Cancel or Confirm):
        this.dialogRef.instance.onDialogConfirm.subscribe(() => {

            this.unsuspendDriver();
            this.dialogRef.destroy();
        });
        this.dialogRef.instance.onDialogCancel.subscribe(() => {

            // this.updateDrinkSafe(false)
            this.dialogRef.destroy();
        });
    }

    onUnpairConfirm() {
        this.makeUnpairDeviceRequest();
    }

    onUnpairCancel() {
        // do nothing - maybe show notification
        this.showNotification('Unpair was cancelled', 'info');
    }

    getCarDetails() {
        this.restService.getCarDetails(this.carItem.CarIdentifier)
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {
                        /* noop */
                    }
                )
            ).subscribe((res: any) => {
                if (this.dataService.isResponseSuccessful(res)) {
                    this.carDetails = res.Car;
                    this.updateShouldUnpairBeVisible();
                }
            },
            () => {
                /* noop */
            }
        );
    }

    updateDrinkSafe(isDrinkSafe: boolean) {
        const body = {
            IsDrinkSafe: isDrinkSafe,
            CarIdentifier: this.carDetails.CarIdentifier,
            CityId: this.carDetails.CityId,
            CompanyId: this.carDetails.CompanyIdentifierId,
        };
        this.restService.updateDrinkSafe(body).pipe(
            finalize(() => {
                this.uiBlockerService.unBlockUI();
            }),
            tap(() => {
                    /* noop */
                },
                () => {
                    /* noop */
                })
        ).subscribe(() => {

            this.getCarDetails();
        }, () => { /* noop */
        });
    }


    updatePackage() {
        const body = {
            Package: this.dialogRef.instance.packageType,
            CarIdentifier: this.carDetails.CarIdentifier,
            CityId: this.carDetails.CityId,
            CompanyId: this.carDetails.CompanyIdentifierId,
            Tariff: this.dialogRef.instance.priceInput,
        };

        this.restService.updatePackage(body).pipe(
            finalize(() => {
                this.uiBlockerService.unBlockUI();
            }),
            tap(() => {
                    /* noop */
                },
                () => {
                    /* noop */
                })
        ).subscribe(() => {

            this.getCarDetails();
        }, () => { /* noop */
        });
    }


    suspendDriver() {
        const body = {
            SuspensionType: 'complaint',
            CarId: this.carDetails.CarId,
            HoursCount: this.dialogRef.instance.suspensionHours,
            Reason: this.dialogRef.instance.suspendReason,
            CompanyIdentifier: this.carDetails.CompanyIdentifier,
            CityId: this.carDetails.CityId || 1,
            CompanyId: this.carDetails.CompanyIdentifierId || 4769,
        };

        this.restService.suspendDriver(body).pipe(
            finalize(() => {
                this.uiBlockerService.unBlockUI();
            }),
            tap(() => {
                    /* noop */
                },
                () => {
                    /* noop */
                })
        ).subscribe(() => {

            this.onCarUpdated.emit();
            this.getCarDetails();
        }, () => { /* noop */
        });
    }

    // unsuspend
    unsuspendDriver() {
        const body = {
            SuspensionType: 'complaint',
            CarId: this.carDetails.CarId,
            CompanyIdentifier: this.carDetails.CompanyIdentifier,
            CityId: this.carDetails.CityId || 1,
            CompanyId: this.carDetails.CompanyIdentifierId || 4769
        };
        this.restService.unsuspendDriver(body).pipe(
            finalize(() => {
                this.uiBlockerService.unBlockUI();
            }),
            tap(() => {
                    /* noop */
                },
                () => {
                    /* noop */
                })
        ).subscribe(() => {

            this.onCarUpdated.emit();
            this.getCarDetails();
        }, () => { /* noop */
        });
    }

    updateShouldUnpairBeVisible() {
        if (this.carDetails.DeviceId === '' && this.carDetails.PairingIdentifier === '') {
            this.shouldUnpairBeVisible = false;
        }

    }

    getDriverPhone(driver: any): string {
        if (isNullOrUndefined(driver)) {
            return '';
        }

        return this.normalizePhoneNumber(driver.DriverPhone);
    }

    normalizePhoneNumber(phoneNumber: any): string {
        if (isNullOrUndefined(phoneNumber)) {
            return '';
        }

        const trimmedPhoneNumber = String(phoneNumber).trim();
        const prefix = trimmedPhoneNumber.charAt(0) === '+' ? '+' : '';
        const digits = trimmedPhoneNumber.replace(/\D/g, '');

        return digits === '' ? '' : prefix + digits;
    }

    unpairDevice() {
        this.restService.unpairDevice(this.carItem.CarIdentifier)
            .pipe(
                finalize(() => {
                    this.uiBlockerService.unBlockUI();
                }),
                tap(
                    () => {
                        /* noop */
                    },
                    () => {
                        /* noop */
                    }
                )
            ).subscribe((res: any) => {
                if (this.dataService.isResponseSuccessful(res)) {
                    // we should show notification with unpair ok
                    this.showNotification('Unpair was completed with success', 'success');
                } else {
                    // we should show notification with unpair fail
                    this.showNotification('Failed to make the unpair', 'danger');
                }
            },
            () => {

                // we should show notification with unpair fail
                this.showNotification('Failed to make the unpair', 'danger');
            }
        );
    }


    onCancelClick() {
        this.onDialogCancel.emit();
    }

    onHide() {
        this.onDialogCancel.emit();
    }

    onCloseClick() {
        this.onDialogCancel.emit();
    }

    onDriverSelected(driverIdentifier: string) {
        // sredirect to driver page using the identifier

        if (!isNullOrUndefined(driverIdentifier)) {
            // and now navigate
            this.router.navigate(['/central/driver/' + driverIdentifier]);
        }
    }

    showNotification(messageReceived: string, typeReceived: string) {
        clearTimeout(this.notificationTimer);
        this.notificationMessage = this.translationService.translate(messageReceived);
        this.notificationType = typeReceived;
        this.notificationTimer = setTimeout(() => {
            this.notificationMessage = '';
        }, 2000);
    }

    private hasActiveGeneralDialog() {
        return !isNullOrUndefined(this.dialogRef) && !this.dialogRef.hostView.destroyed;
    }

}
